import React from "react";
import { Link } from "react-router-dom";
import App1Image from "../../images/app/01.webp";
import App2Image from "../../images/app/02.webp";

const Footer = () => {
  return (
    <footer className="e-footer bg-[#002138] lg:py-10 py-8 relative mb-14 lg:mb-0">
      <div className="container mx-auto">
        <ul className="md:flex hidden flex-wrap justify-center items-center gap-5 divide-x-2 divide-gray-500 pb-4  border-b border-gray-500">
          <li className="pl-4">
            <Link
              to="/privacy-policy"
              className="text-white xl:text-base text-sm font-barlow font-medium text-opacity-80"
            >
              Privacy Policy
            </Link>
          </li>
          <li className="pl-4">
            <Link
              to="/terms-of-service"
              className="text-white xl:text-base text-sm font-barlow font-medium text-opacity-80"
            >
              Terms Of service
            </Link>
          </li>
          {/* <li className="pl-4">
            <Link
              to="/accessibility"
              className="text-white xl:text-base text-sm font-barlow font-medium text-opacity-80"
            >
              Accessibility
            </Link>
          </li> */}
          <li className="pl-4">
            <Link
              to="/contact-us"
              className="text-white xl:text-base text-sm font-barlow font-medium text-opacity-80"
            >
              Contact Us
            </Link>
          </li>
        </ul>
        <div className="footer-bottom">
          <ul className="flex justify-center items-center gap-5 md:py-6 pb-6">
            <li>
              <a href="#0">
                <img src={App1Image} alt="apple store" />
              </a>
            </li>
            <li>
              <a href="#0">
                <img src={App2Image} alt="play store" />
              </a>
            </li>
          </ul>
          <h4 className="text-white lg:text-2xl text-xl font-medium font-barlow uppercase text-center pb-3">
            Follow Us
          </h4>
          <div className="flex justify-center items-center gap-3">
            <a
              href="https://www.facebook.com/BritishMarketplace"
              className="inline-flex justify-center items-center bg-gradient-to-b from-[#028FF0] to-[#02F0C3] h-8 w-8 rounded-full hover:from-[#02F0C3] hover:to-[#028FF0]"
            >
              <svg
                className="h-5 w-5"
                viewBox="0 0 11 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.55829 10.5522L10.0562 7.28685H6.95375V5.17167C6.93087 4.92769 6.96291 4.68165 7.04748 4.45189C7.13206 4.22212 7.26699 4.01456 7.44223 3.84465C7.61747 3.67473 7.82849 3.54686 8.05959 3.47054C8.29068 3.39423 8.53588 3.37145 8.77693 3.4039H10.1864V0.632543C9.35812 0.495385 8.52084 0.420572 7.6815 0.408691C5.12293 0.408691 3.45296 1.95261 3.45296 4.80114V7.28685H0.610954V10.5522H3.45296V18.4339C4.03051 18.5274 4.61458 18.5739 5.19953 18.5729C5.78701 18.5736 6.3736 18.5271 6.95375 18.4339V10.5522H9.55829Z"
                  fill="white"
                />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/britishmarket_place"
              className="inline-flex justify-center items-center bg-gradient-to-b from-[#028FF0] to-[#02F0C3] h-8 w-8 rounded-full hover:from-[#02F0C3] hover:to-[#028FF0]"
            >
              <svg
                className="w-5 h-5"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.8776 3.01709C10.7261 3.01709 10.578 3.06235 10.452 3.14718C10.3261 3.232 10.2279 3.35257 10.1699 3.49363C10.1119 3.63468 10.0967 3.78989 10.1263 3.93963C10.1559 4.08938 10.2288 4.22693 10.3359 4.3349C10.4431 4.44286 10.5796 4.51638 10.7282 4.54617C10.8768 4.57595 11.0308 4.56066 11.1707 4.50223C11.3107 4.4438 11.4304 4.34488 11.5145 4.21793C11.5987 4.09098 11.6437 3.94173 11.6437 3.78905C11.6437 3.58431 11.5629 3.38795 11.4193 3.24318C11.2756 3.09841 11.0808 3.01709 10.8776 3.01709Z"
                  fill="white"
                />
                <path
                  d="M7.46107 4.01319C6.81986 4.01167 6.19262 4.20189 5.65874 4.55977C5.12486 4.91764 4.70835 5.42708 4.46192 6.02361C4.2155 6.62015 4.15023 7.27696 4.27439 7.91089C4.39855 8.54482 4.70656 9.12738 5.15942 9.58483C5.61228 10.0423 6.18965 10.354 6.81843 10.4807C7.4472 10.6073 8.09911 10.5431 8.69165 10.2961C9.28419 10.0492 9.79072 9.6307 10.1471 9.09354C10.5035 8.55639 10.6937 7.92475 10.6937 7.27859C10.6917 6.41451 10.3507 5.5863 9.74515 4.97458C9.13956 4.36287 8.31851 4.01727 7.46107 4.01319ZM7.46107 9.36289C7.04983 9.36441 6.6474 9.24283 6.30484 9.01354C5.96228 8.78426 5.69502 8.4576 5.53695 8.07502C5.37887 7.69245 5.33711 7.27117 5.41697 6.86464C5.49683 6.45812 5.6947 6.08465 5.98549 5.79161C6.27628 5.49857 6.64689 5.29917 7.0503 5.2187C7.45371 5.13822 7.87174 5.1803 8.25138 5.3396C8.63103 5.49889 8.95517 5.76823 9.1827 6.11344C9.41023 6.45865 9.53088 6.86417 9.52937 7.27859C9.52132 7.82601 9.29987 8.34826 8.91285 8.73249C8.52584 9.11672 8.00435 9.33206 7.46107 9.332V9.36289Z"
                  fill="white"
                />
                <path
                  d="M10.0274 13.8939H4.78002C3.73434 13.8918 2.73206 13.4723 1.99265 12.7272C1.25323 11.9821 0.83694 10.9721 0.834915 9.91829V4.63037C0.83694 3.5766 1.25323 2.56659 1.99265 1.82146C2.73206 1.07634 3.73434 0.656825 4.78002 0.654785H10.0274C11.0731 0.656825 12.0753 1.07634 12.8147 1.82146C13.5542 2.56659 13.9704 3.5766 13.9725 4.63037V9.91829C13.9704 10.9721 13.5542 11.9821 12.8147 12.7272C12.0753 13.4723 11.0731 13.8918 10.0274 13.8939ZM4.78002 1.90536C4.06284 1.90536 3.37504 2.19245 2.86792 2.70349C2.3608 3.21453 2.07591 3.90765 2.07591 4.63037V9.91829C2.07591 10.641 2.3608 11.3341 2.86792 11.8452C3.37504 12.3562 4.06284 12.6433 4.78002 12.6433H10.0274C10.7446 12.6433 11.4324 12.3562 11.9395 11.8452C12.4466 11.3341 12.7315 10.641 12.7315 9.91829V4.63037C12.7315 3.90765 12.4466 3.21453 11.9395 2.70349C11.4324 2.19245 10.7446 1.90536 10.0274 1.90536H4.78002Z"
                  fill="white"
                />
              </svg>
            </a>
            <a
              href="https://twitter.com/BritishMarketp1"
              className="inline-flex justify-center items-center bg-gradient-to-b from-[#028FF0] to-[#02F0C3] h-8 w-8 rounded-full hover:from-[#02F0C3] hover:to-[#028FF0]"
            >
              <svg
                className="h-5 w-5"
                viewBox="0 0 13 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.7897 1.39514C12.393 1.56707 11.9759 1.68643 11.5487 1.75024C11.7479 1.75024 12.039 1.35655 12.1616 1.20988C12.3443 0.98085 12.4821 0.718869 12.5676 0.437922C12.5676 0.437922 12.5676 0.391591 12.5676 0.376152C12.5569 0.370723 12.5451 0.367907 12.5331 0.367907C12.5211 0.367907 12.5093 0.370723 12.4986 0.376152C12.0365 0.627299 11.5449 0.819222 11.0355 0.947418C11.0206 0.957058 11.0034 0.962165 10.9857 0.962165C10.968 0.962165 10.9507 0.957058 10.9359 0.947418L10.8057 0.816174C10.5958 0.632199 10.3578 0.483605 10.1009 0.376152C9.75326 0.2362 9.37914 0.17558 9.00547 0.198617C8.64726 0.226109 8.29819 0.325845 7.97898 0.491941C7.65874 0.663711 7.37505 0.897147 7.144 1.179C6.90798 1.4733 6.73811 1.81567 6.64608 2.18253C6.57713 2.53424 6.57713 2.89614 6.64608 3.24784C6.64608 3.30188 6.64607 3.3096 6.59245 3.30188C4.65499 3.10316 2.86058 2.18389 1.55957 0.723543C1.49829 0.654067 1.46765 0.654067 1.42169 0.723543C1.15969 1.21028 1.06066 1.76926 1.13934 2.31729C1.21801 2.86532 1.47019 3.37311 1.85834 3.76506C1.95792 3.8577 2.0575 3.95804 2.16475 4.04296C1.82549 4.01566 1.4949 3.92123 1.19189 3.76506C1.13827 3.72647 1.10763 3.76507 1.09997 3.81911C1.08872 3.91398 1.08872 4.00986 1.09997 4.10473C1.15826 4.56239 1.33665 4.99609 1.61673 5.36112C1.89682 5.72614 2.26845 6.00928 2.69332 6.1813C2.79658 6.22656 2.90449 6.2602 3.01506 6.28163C2.70024 6.32981 2.37999 6.32981 2.06516 6.28163C1.99622 6.28163 1.96558 6.28165 1.99622 6.36656C2.15707 6.79784 2.4256 7.18001 2.77584 7.47616C3.12608 7.77231 3.54619 7.97242 3.99559 8.05715C4.08752 8.05715 4.17179 8.05715 4.26371 8.09574C4.04156 8.44312 3.26018 8.69788 2.90014 8.82911C2.23495 9.06611 1.52685 9.15564 0.824182 9.09158C0.709277 9.09158 0.686295 9.09158 0.655653 9.09158C0.625011 9.09158 0.655653 9.1379 0.655653 9.16878L1.0923 9.42351C1.53319 9.66069 1.99802 9.84962 2.47883 9.98705C3.71744 10.3627 5.03219 10.4043 6.29175 10.1076C7.5513 9.81098 8.71154 9.18646 9.65661 8.29646C10.3364 7.55349 10.8621 6.68117 11.2028 5.7307C11.5435 4.78023 11.6923 3.77074 11.6406 2.7615C11.6406 2.67659 11.7326 2.63799 11.7862 2.59167C12.1599 2.30126 12.4902 1.95808 12.7667 1.5727C12.8092 1.51478 12.8308 1.44397 12.828 1.37199C12.828 1.37199 12.8357 1.39514 12.7897 1.39514Z"
                  fill="white"
                />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/british-marketplace/"
              className="inline-flex justify-center items-center bg-gradient-to-b from-[#028FF0] to-[#02F0C3] h-8 w-8 rounded-full hover:from-[#02F0C3] hover:to-[#028FF0]"
            >
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                // xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                className="h-4 w-4 fill-white"
                viewBox="0 0 310 310"
                // xml:space="preserve"
              >
                <g id="XMLID_801_">
                  <path
                    id="XMLID_802_"
                    d="M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73
C77.16,101.969,74.922,99.73,72.16,99.73z"
                  />
                  <path
                    id="XMLID_803_"
                    d="M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4
c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"
                  />
                  <path
                    id="XMLID_804_"
                    d="M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599
c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319
c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995
C310,145.43,300.549,94.761,230.454,94.761z"
                  />
                </g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
              </svg>
            </a>
          </div>
          <div className="copy-text pt-4">
            <p className="text-center text-white font-normal lg:text-base text-sm font-barlow">
              © 2021-2022 Designed &amp; Developed by JRK International Ltd.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
